import { Buildings, Plugs } from "@phosphor-icons/react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import Empresas from "@/pages/Empresas";
import OdooConnections from "@/pages/OdooConnections";

export default function Ajustes() {
  return (
    <div className="mx-auto max-w-[1100px] space-y-6">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Ajustes y configuraciones</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Administra la estructura organizacional y la integración con Odoo 18 SH.
        </p>
      </div>

      <Tabs defaultValue="empresas" className="w-full">
        <TabsList data-testid="ajustes-tabs">
          <TabsTrigger value="empresas" data-testid="tab-empresas">
            <Buildings size={16} className="mr-1.5" aria-hidden="true" /> Empresas
          </TabsTrigger>
          <TabsTrigger value="odoo" data-testid="tab-odoo">
            <Plugs size={16} className="mr-1.5" aria-hidden="true" /> Conexión Odoo
          </TabsTrigger>
        </TabsList>

        <TabsContent value="empresas" className="mt-6">
          <Empresas />
        </TabsContent>
        <TabsContent value="odoo" className="mt-6">
          <OdooConnections />
        </TabsContent>
      </Tabs>
    </div>
  );
}
